import { maskTaxDocumentOnInput } from "./taxDocument";

export function onChangeCurrencyMask(
  e: React.ChangeEvent<HTMLInputElement>,
): any {
  let currency: string | number = e.target.value.replace(/\D/g, "");
  currency = Number(currency);
  currency = `${(currency / 100).toFixed(2)}`;
  currency = currency.replace(".", ",");
  currency = currency.replace(/(\d)(\d{3})(\d{3}),/g, "$1.$2.$3,");
  currency = currency.replace(/(\d)(\d{3}),/g, "$1.$2,");
  e.target.value = `R$ ${currency}`;
}

export function onChangeTaxDocumentMask(
  e: React.ChangeEvent<HTMLInputElement>,
): void {
  e.target.value = maskTaxDocumentOnInput(e.target.value);
}

export function clienteIdMask(cell: string): string {
  let v = cell;
  v = v.replace(/(\d{8})(\d{4})(\d{4})(\d{4})(\d{12})/g, "$1-$2-$3-$4-$5");

  return v;
}

export function onChangePhoneMask(
  e: React.ChangeEvent<HTMLInputElement>,
): void {
  let phone = e.target.value;
  phone = phone.replace(/\D/g, "");
  phone = phone.replace(/^(\d{2})(\d)/g, "($1) $2");
  phone = phone.replace(/(\d)(\d{4})$/, "$1-$2");
  e.target.value = phone;
}

export function onChangeCellMaskBr(e: React.ChangeEvent<HTMLInputElement>) {
  let phone = e.target.value;
  phone = phone.replace(/\D/g, "");
  phone = phone.replace(/^(\d{2})(\d)/g, "($1) $2");
  phone = phone.replace(/(\d)(\d{4})$/, "$1-$2");
  e.target.value = phone;
}

export function onChangeClienteIdMask(e: React.ChangeEvent<HTMLInputElement>) {
  return clienteIdMask(e.target.value);
}
